var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7315 80C63.2268 80 81.4629 62.0914 81.4629 40C81.4629 17.9086 63.2268 0 40.7315 0C18.2361 0 0 17.9086 0 40C0 62.0914 18.2361 80 40.7315 80Z",
    fill: "#2B3990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9556 27.9019C60.1837 27.9019 58.3812 28.8049 56.7713 31.8323L49.4251 45.6848V33.3792C49.4251 29.7079 47.6856 27.9019 44.4623 27.9019C41.2389 27.9019 39.8879 28.9974 38.278 32.0913L31.3203 45.6883V33.5087C31.3203 29.5784 29.7103 27.9019 25.78 27.9019H17.7898C14.7624 27.9019 13.0859 29.3194 13.0859 31.8953C13.0859 34.4712 14.6959 36.0181 17.6603 36.0181H20.9466V51.547C20.9466 55.9289 23.911 58.5048 28.1634 58.5048C32.4157 58.5048 34.3476 56.8284 36.4756 52.898L41.1164 44.2008V51.547C41.1164 55.8624 43.9513 58.5048 48.2701 58.5048C52.589 58.5048 54.1989 57.0243 56.6453 52.898L67.3409 34.8562C69.6613 30.9258 68.0514 27.8984 62.8961 27.8984H62.9591L62.9556 27.9019Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoo);
export default __webpack_public_path__ + "static/media/woo.9f144c07f77188be5a922578fd54e6b6.svg";
export { ForwardRef as ReactComponent };